import React from 'react';
import './Skills.css';

const Skills = () => {

    const skills = [
        {
            color: 'rgb(229,96,39)',
            tool: 'fab fa-html5',
            name: 'HTML5',
        },
        {
            color: 'rgb(39,96,229)',
            tool: 'fab fa-css3-alt',
            name: 'CSS3',
        },
        {
            color: 'rgb(234,212,28)',
            tool: 'fab fa-js',
            name: 'JavaScript',
        },
        {
            color: 'rgb(79,183,211)',
            tool: 'fab fa-react',
            name: 'React JS',
        },
        {
            color: 'rgb(133,19,242)',
            tool: 'fab fa-bootstrap',
            name: 'Bootstrap',
        },
        {
            img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/80px-Tailwind_CSS_Logo.svg.png',
            name: 'Tailwind CSS',
        },
        {
            color: 'rgb(96,174,69)',
            tool: 'fab fa-node',
            name: 'Node Js',
        },
        {
            img: 'data:image/svg+xml;base64,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',
            name: 'MongoDB',
        },
    ]
    return (
        <div id="skills">
            <div className="skills section-container">
                <div className="skill-top">
                    <h1 className="section-title">Sk<span>i</span>lls</h1>
                    <p>So far I have learned many web technologies like HTML, CSS, JavaScript, React JS, a little bit of Node JS, MongoDB and some little bit of knowledge about another web tools, frameworks, libraries</p>
                </div>
                <div className="skill-bottom">
                    {
                        skills.map(skill => <div className="skill-item">
                            <div className="icon">
                                {skill.img ? <img src={skill.img} alt="svgImg" /> : <i style={{'color':`${skill.color}`}} className={skill.tool}></i>}
                            </div>
                            <h2>{skill.name}</h2>
                            <p>{skill.desc}</p>
                        </div>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Skills;